import React from 'react';
import OtkOptionCatalogList from '../../../components/otk/OtkOptionCatalogList';

/** qlty020 — REMOTE_NON_PROGRESSIVE via shared OtkOptionCatalogList */
export default function PreventionList() {
  return <OtkOptionCatalogList resource="preventions" />;
}
